import { useMemo } from "react";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const usePlanDiscountConnectionRoot = () => {
	const { viewModel } = useProductDayTripPlanFormModelContext();
	const { defaultDiscountID } = viewModel;

	/**
	 * コード入力のディスカウントの選択 UI の表示可否
	 */
	const canShowDiscountConnection = useMemo(() => !defaultDiscountID?.value, [defaultDiscountID?.value]);

	return {
		canShowDiscountConnection,
	};
};
